import { Link } from "react-router-dom";
import { RevealLine, Reveal } from "./Reveal";
import { CaretRight } from "@phosphor-icons/react";

export const PageHero = ({ overline, title, subtitle, breadcrumb, image }) => (
    <section className="relative bg-navy overflow-hidden grain pt-32 lg:pt-44 pb-16 lg:pb-24" data-testid="page-hero">
        {image && (
            <div className="absolute inset-0 z-0">
                <img src={image} alt="" aria-hidden className="w-full h-full object-cover opacity-25" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/60" />
            </div>
        )}
        <div className="absolute inset-0 z-[1] bg-grid opacity-50" />
        <div className="relative z-10 mx-auto max-w-[1400px] px-5 lg:px-10">
            <Reveal>
                <nav className="flex items-center gap-2 text-xs text-slate-400 mb-6">
                    <Link to="/" className="hover:text-brand">Home</Link>
                    <CaretRight size={12} />
                    <span className="text-brand">{breadcrumb || title}</span>
                </nav>
            </Reveal>
            {overline && (
                <Reveal>
                    <div className="flex items-center gap-3 mb-5">
                        <span className="h-px w-8 bg-brand" />
                        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">{overline}</span>
                    </div>
                </Reveal>
            )}
            <h1 className="font-display font-extrabold text-white tracking-tight leading-[0.98] text-4xl sm:text-5xl lg:text-[4.5rem] max-w-4xl">
                <RevealLine text={title} delay={0.1} />
            </h1>
            {subtitle && (
                <Reveal delay={0.3}>
                    <p className="mt-6 max-w-2xl text-base lg:text-lg text-slate-300 leading-relaxed">{subtitle}</p>
                </Reveal>
            )}
        </div>
    </section>
);
